var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSoundIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 186,
    height: 186,
    viewBox: "0 0 186 186",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M112.662 26.3205C121.675 20.3763 133.688 26.8475 133.688 37.6433V148.36C133.688 159.163 121.675 165.627 112.662 159.683L66.1617 129.031C65.8472 128.821 65.4781 128.708 65.1 128.706H42.625C36.9726 128.706 31.5517 126.46 27.5548 122.463C23.5579 118.467 21.3125 113.046 21.3125 107.393V78.6098C21.3125 72.9573 23.5579 67.5364 27.5548 63.5396C31.5517 59.5427 36.9726 57.2973 42.625 57.2973H65.1C65.4799 57.2985 65.8519 57.188 66.1695 56.9795L112.662 26.3205Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M160.743 58.1674C159.617 56.7796 158.091 56 156.5 56C154.909 56 153.383 56.7796 152.257 58.1674C151.132 59.5552 150.5 61.4374 150.5 63.4V122.6C150.5 124.563 151.132 126.445 152.257 127.833C153.383 129.22 154.909 130 156.5 130C158.091 130 159.617 129.22 160.743 127.833C161.868 126.445 162.5 124.563 162.5 122.6V63.4C162.5 61.4374 161.868 59.5552 160.743 58.1674Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSoundIcon);
export default __webpack_public_path__ + "static/media/sound-icon.0f648890838c7ed7597d896601c43295.svg";
export { ForwardRef as ReactComponent };